import { useState } from 'react';
import { toast } from 'sonner';
import { ShieldAlert, Loader2, Play } from 'lucide-react';
import { AdminPageHeader, API } from './_P1Common';
import { useAdmin } from '@/hooks/useAdmin';

export default function AdminSanitize() {
  const { authFetch } = useAdmin();
  const [limit, setLimit] = useState(50);
  const [dryRun, setDryRun] = useState(true);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const run = async () => {
    setLoading(true);
    try {
      const r = await authFetch(`${API}/admin/sanitize`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ dry_run: dryRun, limit }),
      });
      const j = await r.json();
      setResult(j);
      toast.success(dryRun ? 'Simulacija završena' : 'Sanitacija primijenjena');
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-sanitize">
      <AdminPageHeader icon={ShieldAlert} title="Sanitacija sadržaja" subtitle="Skupno čišćenje HTML-a (script, iframe, inline style)"/>
      <div className="px-4 md:px-6 pb-6 max-w-2xl space-y-3">
        <div className="flex items-center gap-3">
          <label className="text-sm">Broj članaka:</label>
          <input type="number" value={limit} onChange={(e) => setLimit(Number(e.target.value))} data-testid="sanitize-limit"
                 className="bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm w-24"/>
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={dryRun} onChange={(e) => setDryRun(e.target.checked)} data-testid="sanitize-dryrun"/>
          Pokreni u test modu (ništa se ne sprema)
        </label>
        <button onClick={run} disabled={loading} data-testid="sanitize-run"
                className="inline-flex items-center gap-1 px-3 py-2 rounded bg-red-600 hover:bg-red-700 text-white text-sm font-bold disabled:opacity-50">
          {loading ? <Loader2 size={14} className="animate-spin"/> : <Play size={14}/>}
          Pokreni sanitaciju
        </button>
        {result && (
          <div className="border border-zinc-800 rounded p-4 bg-zinc-900/50 mt-4">
            <p className="text-sm">Provjereno: <b>{result.checked}</b>, izmijenjeno: <b className="text-red-400">{result.affected}</b> članaka ({result.dry_run ? 'test mod' : 'uživo'})</p>
            <ul className="mt-2 text-xs text-zinc-300 space-y-1 max-h-64 overflow-auto">
              {(result.items || []).map(i => (
                <li key={i.id}>• {i.title} — uklonjeno {i.removed} elemenata</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
